import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  companyId: string | number;
}

export function useDeleteCompany() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ companyId }: Params) =>
      del({
        url: `/companies/${companyId}`,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies('all', true, true) }),
  });

  const deleteCompany = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteCompany,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
